export const GOOGLE_ANALYTICS_ID = "G-SWJDW94D6J";
